import { Routes, Route, Navigate, useParams, useLocation, BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";

import { TranslationProvider } from "@/i18n/TranslationContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

const LangShell = () => {
  const { lang } = useParams();
  const location = useLocation();
  const safeLang = lang === "en" ? "en" : lang === "ar" ? "ar" : null;

  if (!safeLang) {
    return <Navigate to="/ar" replace />;
  }

  return (
    <TranslationProvider lang={safeLang}>
      <div className="flex flex-col min-h-screen bg-white ecominarg-app">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route index element={<Home />} />
            <Route path="privacy-policy" element={<LegalPage tKey="privacy" />} />
            <Route path="cookie-policy" element={<LegalPage tKey="cookie_policy" />} />
            <Route path="terms-conditions" element={<LegalPage tKey="terms" />} />
            <Route path="*" element={<Navigate to={`/${safeLang}`} replace />} />
          </Routes>
        </div>
        <Footer />
        <CookieBanner langBasePath={`/${safeLang}`} />
      </div>
    </TranslationProvider>
  );
};

const ThankYouShell = () => {
  useEffect(() => {
    document.documentElement.setAttribute("lang", "es-AR");
  }, []);
  // Thank-you is single-language (Spanish). Wrap with TranslationProvider("ar") so
  // Header/Footer text still renders in Spanish.
  return (
    <TranslationProvider lang="ar">
      <div className="flex flex-col min-h-screen bg-white ecominarg-app">
        <Header />
        <div className="flex-1">
          <ThankYou />
        </div>
        <Footer />
        <CookieBanner langBasePath={`/ar`} />
      </div>
    </TranslationProvider>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Root redirect to Spanish */}
        <Route path="/" element={<Navigate to="/ar" replace />} />
        {/* Thank-you \u2014 single language, own URL */}
        <Route path="/thank_you" element={<ThankYouShell />} />
        {/* Language-prefixed routes */}
        <Route path="/:lang/*" element={<LangShell />} />
        <Route path="*" element={<Navigate to="/ar" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
